export default "__VITE_ASSET__DPKDOi8n__"